/**
 * タブ操作を管理するクラス
 */
export class Tabs {
	/**
	 * コンストラクタ
	 * @param {string} selector - タブ要素を指定するセレクタ
	 */
	constructor(selector) {
		this.$tabs = $(selector);
		this.init();
	}

	/**
	 * タブの初期化処理を行う
	 * - 初回にアクティブなタブを設定
	 * - クリックイベントをバインド
	 */
	init() {
		// アクセシビリティ用のrole属性を追加
		this.$tabs.attr('role', 'tablist'); // タブリスト
		this.$tabs.find('.js-tab_btn').attr('role', 'tab'); // タブボタン
		this.$tabs.find('.js-tab_content').attr('role', 'tabpanel'); // タブコンテンツ

		// 最初のタブをアクティブ化
		this.firstActiveTab();

		// クリックイベントを設定
		this.$tabs.find('.js-tab_btn').on('click', (event) => {
			event.preventDefault();
			this.switchTab(event);
		});
	}

	/**
	 * 最初のタブをアクティブにする
	 */
	firstActiveTab() {
		this.$tabs.each(function () {
			// 全タブとコンテンツを非アクティブに
			$(this).find('.js-tab_btn')
				.attr('aria-selected', 'false')
				.removeClass('is-active');
			$(this).find('.js-tab_content')
				.attr('aria-hidden', 'true')
				.removeClass('is-active');

			// 最初のタブとコンテンツをアクティブ化
			$(this).find('.js-tab_btn').eq(0)
				.attr('aria-selected', 'true')
				.addClass('is-active');
			$(this).find('.js-tab_content').eq(0)
				.attr('aria-hidden', 'false')
				.addClass('is-active');
		});
	}

	/**
	 * タブの切り替えを行う
	 * @param {Event} event - クリックイベント
	 */
	switchTab(event) {
		const $targetIndex = $(event.currentTarget).index();

		this.$tabs.each(function () {
			// すべてのタブとコンテンツを非アクティブ化
			$(this).find('.js-tab_btn')
				.attr('aria-selected', 'false')
				.removeClass('is-active');
			$(this).find('.js-tab_content')
				.attr('aria-hidden', 'true')
				.removeClass('is-active');

			// 対応するコンテンツを表示
			$(this).find('.js-tab_content').eq($targetIndex)
				.attr('aria-hidden', 'false')
				.addClass('is-active');
		});

		// クリックされたタブをアクティブ化
		$(event.currentTarget)
			.attr('aria-selected', 'true')
			.addClass('is-active');
	}
}
